import React, { useContext } from 'react';
import './BevDisplay.css';
import { StoreContext } from '../context/StoreContext';
import BeverageItem from '../BeverageItem/BeverageItem';

export default function BevDisplay({ category, searchQuery }) {
  const { bev_list } = useContext(StoreContext);

  return (
    <>
      <div className='bev-display' id='bev-display'>
        <div className='coffee-display-list'>
          {bev_list
            .sort((a, b) => a.name.localeCompare(b.name))
            .filter(item => {
              const matchesCategory = category === "All" || category === item.category;
              const matchesSearchQuery = item.name.toLowerCase().includes(searchQuery.toLowerCase());
              return matchesCategory && matchesSearchQuery;
            })
            .map(item => (
              <BeverageItem key={item._id} id={item._id} name={item.name} image={item.image} />
            ))
          }
          
        </div>
      </div>
    </>
  );
}



// {price_list.map((item)=>{
//   return <Cart key={item._id} id={item._id} size={item.size} price={item.price}/>
// })}
